import { useEffect, useRef } from 'react'
import { reportDeviceTimezone } from '@/shared/api'
import { deviceTimeZone } from '@/shared/lib'
import { isEmployee } from '../model/types'
import { useSession } from './use-session'

// Зона сотрудника, известная хабу, — снимок зоны его устройства, и переставляет
// её SPA. Нужна она там, где экрана нет: письмо и телеграм-алерт хаб рендерит
// на сервере и час встречи подставляет из своей проекции сотрудника. В самом
// интерфейсе эта запись ни на что не влияет — момент показывается в зоне
// устройства напрямую, без хранилища.
//
// Спрашивать человека нечего: зона — не настройка, люди летают, а сохранённая
// настройка отстаёт молча. Административный SPA хаба зону тоже пишет, но люди
// живут в продуктах, а не в администрировании, — поэтому её сообщает и дил.
//
// Раз на загрузку: ручка идемпотентна (тем же значением хаб не пишет), а
// перелёт посреди сессии догонит следующая загрузка. Отказ не эскалируется —
// это фоновая запись, а не действие пользователя.
export function useDeviceTimezoneSync(): void {
  const { session } = useSession()
  // Заказчику слать нечего: записи сотрудника в хабе у него нет.
  const employee = isEmployee(session)
  const reported = useRef(false)

  useEffect(() => {
    if (!employee || reported.current) return
    const zone = deviceTimeZone()
    // Движок без IANA-зоны: слать нечего — пустым значением затёрли бы то, что
    // хаб уже знает.
    if (!zone) return
    reported.current = true
    void reportDeviceTimezone(zone)
  }, [employee])
}
